import { TransportModel } from '../../transport/model/transport-model';
import { UserModal } from '../../user/modal/user-modal';
import { SegmentModel } from '../../segment/model/segment-model';
import { VendorDetailModal } from './vendor-detail-modal';
import { VendorDetailsBranchModel } from './vendor-details-branch-model';

export class VendorModal {
  id: number;
  companyName: string;
  gstNumber: string;
  panNumber: string;
  companyWebsite: string;
  billAddress: string;
  billAddress2: string;
  billAddress3: string;
  shippingAddress: string;
  shippingAddress2: string;
  shippingAddress3: string;
  state: string;
  stateCode:string;
  partyType: any;
  productTypes:[]
  partyTypeCategory: any;
  accountHolderName: string;
  accountNumber: number;
  bankName: string;
  ifscCode: string;
  contactDetails: Array<VendorDetailModal>;
  country: string;
  transports: TransportModel[];
  selectedCountry: countryModel;
  salesHead: Array<UserModal>;
  vendorCode: string;
  segment: SegmentModel;
  termsOfPayment: string;
  //CBL #Dk
  branchDetails: Array<VendorDetailsBranchModel>;
  owningCompany: number;

  // Angular Use
  currentSalesHead: UserModal;
  partyTypeString: string;

  poBox: any;
  licNo: any;
  IsAuth: any;
  IsAt: any;
  IsOn: any;
  valUp: any;
  bankBranch: any;
  bankSwift: any;
  currency:any;
  resName: any;
  profQua: any;
  mobileN: any;
  emailN: any;
  manStaff: any;
  labour: any;
  ehsPolicyBody: boolean = false;
  isoManual: boolean = false;
  qacManual: boolean = false;
  copyOfCertification: boolean = false;
}

export class countryModel {
  name: string;
  code: string;
}
